import $ from 'jquery';
import Swiper from 'swiper'; 
import "swiper/css/swiper.css"; 

const render = () => {
    var mySwiper = new Swiper('.swiper-container', { 
        loop: true, 
        pagination: {
            el: '.swiper-pagination',
            clickable: true, 
        },
        autoplay: {
            delay: 5000, 
            disableOnInteraction: false
        },
        speed: 1000, 
    
    });
}
render();